var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var GoBackArrow = function () {
    return (_jsxs("svg", __assign({ width: '20', height: '20', viewBox: '0 0 20 20', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, { children: [_jsx("path", { d: 'M9.16699 5L4.16699 10L9.16699 15', stroke: '#3A3E41', strokeWidth: '1.75', strokeLinecap: 'round', strokeLinejoin: 'round' }), _jsx("path", { d: 'M5 10L15.8333 10', stroke: '#3A3E41', strokeWidth: '1.75', strokeLinecap: 'round', strokeLinejoin: 'round' })] })));
};
export default GoBackArrow;
//# sourceMappingURL=GoBackArrow.js.map